// Only anonymous login-change and sign-out markers are stored here, never credentials or personal information.
export const SIGNED_OUT_KEY = 'dtviso.customer.signed-out'
export const SESSION_CHANGED_KEY = 'dtviso.customer.session-changed'
const MOBILE_FLOW_KEY = 'dtviso.customer.wechat-mobile-flow'

export function createBrowserLoginState(storage, tabStorage = null) {
  const marker = () => { try { return storage.getItem(SESSION_CHANGED_KEY) } catch (_) { return null } }
  const signedOutMarker = () => { try { return storage.getItem(SIGNED_OUT_KEY) } catch (_) { return null } }
  let observed = marker()
  return {
    marker,
    changed() { return observed !== marker() },
    signedOutMarker,
    blocked() { return signedOutMarker() !== null },
    beginMobileLogin(state) {
      if (!tabStorage) return
      try {
        tabStorage.setItem(MOBILE_FLOW_KEY, JSON.stringify({ state, login: marker(), logout: signedOutMarker() }))
      } catch (_) { /* Restoration without a sign-out marker can still use the session cookie. */ }
    },
    consumeMobileLogin(state) {
      if (!tabStorage || !/^[a-zA-Z0-9_-]{43}$/.test(state || '')) return false
      try {
        const flow = JSON.parse(tabStorage.getItem(MOBILE_FLOW_KEY))
        if (!flow || flow.state !== state) return false
        tabStorage.removeItem(MOBILE_FLOW_KEY)
        return flow.login === marker() && flow.logout === signedOutMarker()
      } catch (_) { return false }
    },
    block() { try { storage.removeItem(SESSION_CHANGED_KEY); storage.setItem(SIGNED_OUT_KEY, String(Date.now())) } catch (_) { /* Storage may be disabled. */ } },
    allow(broadcast = true) { try { storage.removeItem(SIGNED_OUT_KEY); if (broadcast) storage.setItem(SESSION_CHANGED_KEY, Date.now() + '-' + Math.random().toString(36).slice(2)); observed = marker() } catch (_) { /* Cookie session still works. */ } },
  }
}

// Signals contain no account identifier, token or photo data. Restore never rebroadcasts.
export function applyBrowserSessionEvent(session, event) {
  if (event.newValue === null) return false
  if (event.key === SIGNED_OUT_KEY) session.clear('已在其他页面退出登录。')
  else if (event.key === SESSION_CHANGED_KEY) session.clear('已在其他页面切换登录，请刷新后继续。')
  else return false
  return true
}
